import react from "react";
export default function Resultado(props) {
  return (
    <>
      <span>Valor total : {props.resultado}</span>
    </>
  );
}
